document.addEventListener('DOMContentLoaded', () => {
  const progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;
  const pathLength = progressPath.getTotalLength();

  progressPath.style.transition = 'none';
  progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;

  let lastProgress = null;
  let maxScroll = 1;
  let scrollFrame = null;
  let resizeFrame = null;

  function measureDocument() {
    maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
  }

  function updateProgress() {
    scrollFrame = null;
    const scroll = window.scrollY || window.pageYOffset;
    const progress = pathLength - (scroll * pathLength) / maxScroll;
    if (lastProgress !== progress) {
      progressPath.style.strokeDashoffset = progress;
      lastProgress = progress;
    }
  }

  function requestProgressUpdate() {
    if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(updateProgress);
  }

  function handleResize() {
    if (resizeFrame !== null) return;
    resizeFrame = window.requestAnimationFrame(() => {
      resizeFrame = null;
      measureDocument();
      updateProgress();
    });
  }

  measureDocument();
  updateProgress();
  window.addEventListener('scroll', requestProgressUpdate, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });
  window.addEventListener('load', handleResize, { once: true });
});
